import { render, staticRenderFns } from "./StakeTooltip.vue?vue&type=template&id=66233830&"
import script from "./StakeTooltip.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeTooltip.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports